<template>
  <div>
    <Toolbar :esDocumento="true" />
    <v-card>
      <v-card-text class="text-justify text-body-1">
        Autorizo expresamente a
        <span class="font-weight-bold"
          >Valladolid Caja Financiera, S.C. de A.P. de R.L. de C.V. </span
        >, para lleve a cabo Investigaciones, sobre mi comportamiento Crediticio
        en SIC que estime conveniente. Conozco la naturaleza y alcance de la
        información que se solicitará, del uso que se le dará y que se podrá
        realizar consultas periódicas de mi historial crediticio, consiento que
        esta autorización tenga vigencia de 3 años contados a partir de hoy, y
        en su caso mientras mantengamos relación jurídica.
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Toolbar from '@/components/compartidos/Toolbar.vue'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'

export default {
  name: 'TerminosCondiciones',
  components: {
    Toolbar,
  },
  mixins: [InsertaLogMixin],
  mounted() {
    this.InsertaLog()
  },
  created() {
    this.$store.commit('ESTABLECER_LAYOUT', 'LayoutDocumento')
  },
}
</script>

<style></style>
